import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface SuperAdminRouteProps {
  children: React.ReactNode;
}

export const SuperAdminRoute: React.FC<SuperAdminRouteProps> = ({ children }) => {
  const { user, isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-kanban-blue">
        <div className="text-white text-2xl">Chargement...</div>
      </div>
    );
  }

  // Vérifier l'authentification
  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  // Vérifier le rôle super_admin
  if (user.role !== 'super_admin') {
    // Rediriger vers la page d'accueil avec un message d'erreur
    console.error('Accès refusé : privilèges super administrateur requis');
    return <Navigate to="/boards" replace />;
  }

  // Utilisateur autorisé
  return <>{children}</>;
};
